module.exports = __webpack_public_path__ + "img/LOGISTICA.f82c526d.png";